module.exports = __webpack_public_path__ + "static/home-tickets-27cb4152d4b703fa28697a0a608486e4.png";